import { Component, OnInit, Inject } from "@angular/core";
import { ViewController, NavParams } from "ionic-angular";
import {
  NotificationLogService,
  INotificationLogEvent
} from "../../app/services/notification-log.service";
import {
  ENV_VARS,
  EnvironmentVariables
} from "../../app/environment-variables/environment-variables.module";
import { AdminService } from "../../app/services/admin.service";

@Component({
  selector: "notification-log-modal",
  templateUrl: "notification-log.modal.html"
})
export class NotificationLogModal implements OnInit {
  taskId: string;
  logs: INotificationLogEvent[] = null;
  isProd: boolean = true;
  constructor(
    private viewCtrl: ViewController,
    private notificationLog: NotificationLogService,
    public navParams: NavParams,
    public admin: AdminService,
    @Inject(ENV_VARS) public envVars
  ) {
    this.taskId = navParams.get("taskId") || null;
    this.isProd = this.envVars.ENV === "prod";
  }

  ngOnInit() {}

  ionViewWillEnter() {
    this.notificationLog
      .getLogs(this.taskId)
      .subscribe(result => (this.logs = result));
  }

  dismiss($event) {
    this.viewCtrl.dismiss();
  }
}



// WEBPACK FOOTER //
// ./src/modals/notification-log.modal/notification-log.modal.ts